import { api } from "~/api";
import { defineComponent, reactive, ref, computed } from "vue";
import { MsgBox } from "~/components/MsgBox";
import { Log } from "~/extensions/utils";
import { useRouter } from "vue-router";
import { store } from "./store/ShomeiEntryStore";
import { myPageStore } from "~/store/MyPageStore";
import { commonStore } from "~/store/CommonStore";
import BreadcrumbList from "~/components/BreadcrumbList.vue";
import { PageID } from "~/extensions/utils/DefineTypes";
const log = Log.create("ShomeiPrecautionsPage");
const privacyConsentErrorMessage = "選択してください。";
export default defineComponent({
    components: {
        BreadcrumbList
    },
    name: "ShomeiPrecautionsPage",
    async setup() {
        let html = reactive({
            value: ""
        });
        const router = useRouter();
        const privacyConsent = ref(false);
        const isChangeOrSubmitted = ref(false);
        const isMultipleKeiyaku = myPageStore.isMultipleKeiyaku;
        // 画面名取得
        const pageName = commonStore.pageName(PageID.shomeiPrecautions);
        const valid = reactive({
            privacyConsent: {
                error: computed(() => isChangeOrSubmitted.value && !privacyConsent.value),
                message: computed(() => (isChangeOrSubmitted.value && !privacyConsent.value ? privacyConsentErrorMessage : ""))
            }
        });
        try {
            let result = await api.shomei.loadPrecautionsText();
            html.value = result;
            store.clear();
        }
        catch (ex) {
            log.error("setup", ex);
            MsgBox.error(ex.message);
        }
        const saveConsentAndNavigate = () => {
            isChangeOrSubmitted.value = true;
            if (valid.privacyConsent.error) {
                return;
            }
            // ストアに保持
            store.setPrivacyConsent(privacyConsent.value);
            router.push({ name: "shomei-shinsei" });
        };
        return {
            html,
            valid,
            privacyConsent,
            saveConsentAndNavigate,
            isMultipleKeiyaku,
            isChangeOrSubmitted,
            pageName,
            PageID
        };
    }
});
